import { render, staticRenderFns } from "./LicensePurchaseForm.vue?vue&type=template&id=5d1f775b&scoped=true&"
import script from "./LicensePurchaseForm.vue?vue&type=script&lang=js&"
export * from "./LicensePurchaseForm.vue?vue&type=script&lang=js&"
import style0 from "./LicensePurchaseForm.vue?vue&type=style&index=0&id=5d1f775b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1f775b",
  null
  
)

export default component.exports